import React from 'react'
import Button, { TYPES as BUTTON_TYPES } from '../Button/index'
import { UNAVAILABLE_REASON } from '../../services/share/index'

/**
 * The video error component
 * @param {Object} props.error - The error object
 * @param {Map} props.staticText - The static text
 * @param {Function} props.onClick - The play button click handler
 * @returns {JSX.Element} video error component
 */
function SharePageVideoError (props) {
  const {
    error,
    share,
    onClick,
    staticText,
  } = props

  const imageNoText = share.getIn(['content', 'imageNoText'])
  const unavailableReason = share.get('unavailableReason')

  if (!error && !unavailableReason) {
    return null
  }

  return (
    <div className="share-page__video-error">
      <div
        className="share-page__video-poster"
        style={imageNoText ? { backgroundImage: `url(${imageNoText}}` } : null}
      >
        <div className="share-page__video-error-overlay">
          {error
            ? <div className="share-page__video-not-avaialble">
              <p>{staticText.get('videoNotFound')}</p>
            </div>
            : <div className="share-page__video-not-avaialble">
              {unavailableReason === UNAVAILABLE_REASON.INVALID_EMAIL && <p>{staticText.get('shareError')}</p>}
              {unavailableReason === UNAVAILABLE_REASON.GEO_NOT_AVAILABLE && <p>{staticText.get('notAvailable')}</p>}
              {unavailableReason === UNAVAILABLE_REASON.NOT_SHARABLE && <>
                <p>{staticText.get('noLongerSharable')}</p>
                <Button
                  type={BUTTON_TYPES.ROYAL}
                  onClick={onClick}
                >
                  {staticText.get('watchPreview')}
                </Button>
              </>}
            </div>
          }
        </div>
      </div>
    </div>
  )
}

export default SharePageVideoError
